/* eslint-disable no-unused-vars */

let ruleRequired = (value) => {
  return !!value
}

let ruleRequiredArray = (value) => {
  if (value) {
    return value.length > 0
  }
}

let ruleEmail = (value) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(value)
}

let ruleEmailNoReq = (value) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (value.length > 0) {
    return regex.test(value)
  } else {
    return true
  }
}

let ruleMinChars = (value, length) => {
  return value.length >= length
}

let ruleMinCharsOrNull = (value, length) => {
  if (!value) return true
  return value.length >= length
}

let ruleMaxChars = (value, length) => {
  if (!value) return true
  return value.length <= length
}

let ruleExactChars = (value, length) => {
  return value.length === length
}

let ruleNumeric = (value) => {
  return /^(\d*\.)?\d+$/.test(value)
}

let ruleDigits = (value) => {
  return /\d+$/.test(value)
}

// maxIntDigits and maxDecDigits must be >= 1
let ruleDecimal = (value, maxIntDigits, maxDecDigits) => {
  let decimalRegex = new RegExp('^\\d{1,' + maxIntDigits + '}(\\.\\d{1,' + maxDecDigits + '})?$')
  return decimalRegex.test(value)
}

let ruleText = (value) => {
  const textRegex = /[\/#@*\$%<=>·ªº\\|\]\[{}()\+\-^'`´]/u
  return !textRegex.test(value)
}

let ruleTextFilters = (value) => {
  const textRegex = /[\/#@*\$%<=>·ªº\\|\]\[{}()\+\^'`´]/u
  return !textRegex.test(value)
}

let ruleThreeDigits = (value) => {
  if (!value) return false
  return value.length >= 3
}

let ruleThreeDigitsNoRequired = (value) => {
  if (!value) return true
  return value.length >= 3
}

let ruleZip = (value) => {
  return /^(\d*\.)?\d+$/.test(value)
}

let ruleIsDecimal = (value) => {
  const pattern = /^(\d*\.)?\d+$/
  return pattern.test(value)
}

let ruleOnlyLetters = (value) => {
  return !(/[0-9]/.test(value))
}

let ruleNoSpace = (value) => {
  return !(/[\s]/.test(value))
}

let rulePassword = (value) => {
  return value !== undefined ? (value.length > 7) : false
}

let ruleValidMonth = (value) => {
  let number = parseInt(value)
  return number <=12 && number > 0
}

let ruleValidPassword = (value) => {
  // eslint-disable-next-line
  const pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])(?!.*?["_/()=¿¡‘'`[+\]´¨{ç}<>,;\.:_ºª\|]).{8,}$/
  return pattern.test(value)
}

let ruleTax = (value) => {
  const patern = /([A-Za-z]{3,4}\d{6}[a-zA-Z0-9]{3})$/g
  return patern.test(value)
}

let rulePlate = (value) => {
  const patern = /^[A-Za-z0-9-]{3,10}$/
  return patern.test(value)
}
let ruleWithNull = (value, length) => {
  if (value === null ) {
    return true
  } else {
    return value.length <= length    
  }
}

let positiveNegative = (value) => {
  const patern = /^-?[0-9]+\.?[0-9]+$/
  if (value.length > 0) {
    return patern.test(value)
  } else {
    return true
  }
}

let noSpaceInitial = (value) => {
  return !!value && value.trim().length > 0
}

const validationRules = function () {
  return {
    coordinate: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => positiveNegative(v) || this.$t('validation.coordinate')
    ],
    plate: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => rulePlate(v) || this.$t('validation.plate', { minimo: 3, maximo: 10}),
    ],
    tax: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleTax(v) || this.$t('validation.tax')
    ],
    requiredMultiple: [v => ruleRequiredArray(v) || this.$t('validation.required')],
    required: [v => ruleRequired(v) || this.$t('validation.required')],
    email: [
      v => ruleEmail(v) || this.$t('validation.invalidEmail'),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    emailNoReq: [
      v => ruleEmailNoReq(v) || this.$t('validation.invalidEmail'),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    zipcode: [
      v => ruleDigits(v) || this.$t('validation.invalidNumber'),
      v => ruleExactChars(v, 5) || this.$t('validation.fiveDigits')
    ],
    exchange: [v => ruleDecimal(v, 2, 6) || this.$t('validation.exchange')],
    textRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleThreeDigits(v) || this.$t('validation.minNumberChars', {number: 3}),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    textRulesStrict: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleThreeDigits(v) || this.$t('validation.minNumberChars', {number: 3}),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255}),
      v => noSpaceInitial(v) || this.$t('validation.noSpecialChars')
    ],
    textRulesNoRequired: [
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleThreeDigitsNoRequired(v) || this.$t('validation.minNumberChars', {number: 3}),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    textNoSpecialCharsFilters: [
      v => ruleTextFilters(v) || this.$t('validation.noSpecialChars')
    ],
    textNoSpecialChars: [
      v => ruleText(v) || this.$t('validation.noSpecialChars')
    ],
    textNoReq: [
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    vin: [
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleMaxChars(v,17) || this.$t('validation.maxNumberChars', {number: 17})
    ],
    unitNumber: [
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleWithNull(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    noSpecialChars: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    codePostal: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleMaxChars(v,5) || this.$t('validation.maxNumberChars', {number: 5})
    ],
    zipRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleZip(v) || this.$t('validation.invalidNumber'),
      v => ruleExactChars(v, 5) || this.$t('validation.fiveDigits')
    ],
    streetNumber: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleMinChars(v, 1) || this.$t('validation.minNumberChars', {number: 1}),
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255})
    ],
    taxRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleMinChars(v, 12) || this.$t('validation.minNumberChars', {number: 12}),
      v => ruleMaxChars(v, 13) || this.$t('validation.maxNumberChars', {number: 13})
    ],
    phoneRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleMinChars(v, 10) || this.$t('validation.minNumber', {number: 10})
    ],
    phoneNoRequiredRules: [
      v => ruleMinCharsOrNull(v, 10) || this.$t('validation.minNumber', {number: 10})
    ],
    counter: [
      v => ruleMaxChars(v, 20) || this.$t('validation.maxNumberChars', {number: 20})
    ],
    decimal: [
      v => ruleIsDecimal(v) || this.$t('validation.invalidDecimal')
    ],
    onlyLetters: [
      v => ruleOnlyLetters(v) || this.$t('validation.onlyLetters')
    ],
    digits: [
      v => ruleDigits(v) || this.$t('validation.invalidNumber')
    ],
    minChars: [
      v => ruleMinChars(v, 3) || this.$t('validation.minNumberChars', {number: 3})
    ],
    password: [
      v => rulePassword(v) || this.$t('validation.minNumberChars', {number: 8})
    ],
    validPassword: [
      v => ruleMinChars(v, 8) || this.$t('validation.minNumberChars', {number: 8}),
      // eslint-disable-next-line
      v => ruleValidPassword(v) || this.$t('general.passwordRule') + this.$t('validation.nonAllowedCharacters') + ': “ _ / ( ) = ¿ ¡ ‘ ` [ + ] ´ ¨ { ç } < > , ; . : _ º ª \ |'
    ],
    minNameUser: [
      v => ruleMinChars(v, 5) || this.$t('validation.minNumberChars', {number: 5})
    ],
    expirationYear: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleExactChars(v, 2) || this.$t('validation.exactNumberDigits', {number: 2}),
      v => ruleDigits(v) || this.$t('validation.invalidNumber')
    ],
    cvv: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleExactChars(v, 3) || this.$t('validation.exactNumberDigits', {number: 3}),
      v => ruleDigits(v) || this.$t('validation.invalidNumber')
    ],
    expirationMonth: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleDigits(v) || this.$t('validation.invalidNumber'),
      v => ruleValidMonth(v) || this.$t('validation.invalidMonth')
    ],
    card: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleDigits(v) || this.$t('validation.invalidNumber'),
      v => ruleMinChars(v, 16) || this.$t('validation.minNumberDigits', {number: 16}),
      v => ruleMaxChars(v, 19) || this.$t('validation.maxNumberDigits', {number: 19})
    ],
    noSpace: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleNoSpace(v) || this.$t('validation.noSpace')
    ],
    maxText: [
      v => ruleMaxChars(v,255) || this.$t('validation.maxNumberChars', {number: 255}),
      v => ruleText(v) || this.$t('validation.noSpecialChars')
    ],
    specificDecimal: [v => ruleDecimal(v, 15, 3) || this.$t('validation.specificDecimal')],
  }
}

export default validationRules
